
const SplashFooter = () => {
  return (
    <footer className="site-footer">
      <div>
        <strong>Indian Park Association</strong>
        <span>A volunteer-run lakeside community since 1936.</span>
      </div>
      <p>Greenwood Lake, New York</p>
    </footer>
  )
}

export default SplashFooter
